import { render, staticRenderFns } from "./EventCancellationPolicy_es_packages.vue?vue&type=template&id=f59ab700&"
import script from "./EventCancellationPolicy_es_packages.vue?vue&type=script&lang=js&"
export * from "./EventCancellationPolicy_es_packages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports